import * as bootstrap from "bootstrap";
// Extend Tooltip to add color options
bootstrap.Tooltip.prototype.show = ((original) => {
    return function addTooltipColor() {
        if (this._config.toggle === "tooltip") {
            if (this._element.getAttribute("data-color")) {
                const str = `tooltip-${this._element.getAttribute("data-color")}`;
                this.getTipElement().classList.add(str);
            }
        }
        original.apply(this);
    };
})(bootstrap.Tooltip.prototype.show);
// Extend Popover to add color options
bootstrap.Popover.prototype.show = ((original) => {
    return function addPopoverColor() {
        if (this._config.toggle === "popover") {
            if (this._element.getAttribute("data-color")) {
                const str = `popover-${this._element.getAttribute("data-color")}`;
                this.getTipElement().classList.add(str);
            }
        }
        original.apply(this);
    };
})(bootstrap.Popover.prototype.show);
document.addEventListener("DOMContentLoaded", function () {
    // make it as accordion for smaller screens
    if (window.innerWidth < 992) {
        // close all inner dropdowns when parent is closed
        document
            .querySelectorAll(".navbar .dropdown")
            .forEach(function (everydropdown) {
            everydropdown.addEventListener("hidden.bs.dropdown", function () {
                // after dropdown is hidden, then find all submenus
                this.querySelectorAll(".submenu").forEach(function (everysubmenu) {
                    // hide every submenu as well
                    everysubmenu.style.display = "none";
                });
            });
        });
        document.querySelectorAll(".dropdown-menu a").forEach(function (element) {
            element.addEventListener("click", function (e) {
                let nextEl = this.nextElementSibling;
                if (nextEl && nextEl.classList.contains("submenu")) {
                    // prevent opening link if link needs to open dropdown
                    e.preventDefault();
                    if (nextEl.style.display == "block") {
                        nextEl.style.display = "none";
                    }
                    else {
                        nextEl.style.display = "block";
                    }
                }
            });
        });
    }
    // end if innerWidth
});
// DOMContentLoaded  end
// fix for dropdowns inside overflow-x auto
$("table .dropdown").on("show.bs.dropdown", function () {
    const dropdown = $(this);
    const offset = dropdown.offset();
    if (!offset) {
        return;
    }
    $("body").append($(this)
        .find(".dropdown-menu")
        .css({
        position: "absolute",
        left: offset.left,
        top: offset.top,
    })
        .detach());
});
try {
    window.bootstrap = bootstrap;
}
catch (e) { }
export { bootstrap };
